import { Union, Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { union_type, record_type, int32_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";

export class PortingStatus extends Record {
    constructor(Cancelled, Denied, DoneLastWeekday, Waiting, WaitingNextWeekday, MissingSnpacPortations) {
        super();
        this.Cancelled = (Cancelled | 0);
        this.Denied = (Denied | 0);
        this.DoneLastWeekday = (DoneLastWeekday | 0);
        this.Waiting = (Waiting | 0);
        this.WaitingNextWeekday = (WaitingNextWeekday | 0);
        this.MissingSnpacPortations = (MissingSnpacPortations | 0);
    }
    get ActionCount() {
        const x = this;
        return ((x.Cancelled + x.Denied) + x.MissingSnpacPortations) | 0;
    }
}

export function PortingStatus$reflection() {
    return record_type("Containers.StatusAndWarnings.Model.PortingStatus", [], PortingStatus, () => [["Cancelled", int32_type], ["Denied", int32_type], ["DoneLastWeekday", int32_type], ["Waiting", int32_type], ["WaitingNextWeekday", int32_type], ["MissingSnpacPortations", int32_type]]);
}

export class InvoicingStatus extends Record {
    constructor(AddressMissing, CustomerNoNextInvoice, EmailDistributionNoEmail, SubscriptionNoNextInvoice, WrongCountryAddress, ReturnEAWithMissingAddress, GDPRCustomers) {
        super();
        this.AddressMissing = (AddressMissing | 0);
        this.CustomerNoNextInvoice = (CustomerNoNextInvoice | 0);
        this.EmailDistributionNoEmail = (EmailDistributionNoEmail | 0);
        this.SubscriptionNoNextInvoice = (SubscriptionNoNextInvoice | 0);
        this.WrongCountryAddress = (WrongCountryAddress | 0);
        this.ReturnEAWithMissingAddress = (ReturnEAWithMissingAddress | 0);
        this.GDPRCustomers = (GDPRCustomers | 0);
    }
    get ActionCount() {
        const x = this;
        return ((((((x.AddressMissing + x.CustomerNoNextInvoice) + x.EmailDistributionNoEmail) + x.SubscriptionNoNextInvoice) + x.WrongCountryAddress) + x.ReturnEAWithMissingAddress) + x.GDPRCustomers) | 0;
    }
}

export function InvoicingStatus$reflection() {
    return record_type("Containers.StatusAndWarnings.Model.InvoicingStatus", [], InvoicingStatus, () => [["AddressMissing", int32_type], ["CustomerNoNextInvoice", int32_type], ["EmailDistributionNoEmail", int32_type], ["SubscriptionNoNextInvoice", int32_type], ["WrongCountryAddress", int32_type], ["ReturnEAWithMissingAddress", int32_type], ["GDPRCustomers", int32_type]]);
}

export class DirectDebitStatus extends Record {
    constructor(PendingApplications, ApprovedApplications, NotApprovedApplications) {
        super();
        this.PendingApplications = (PendingApplications | 0);
        this.ApprovedApplications = (ApprovedApplications | 0);
        this.NotApprovedApplications = (NotApprovedApplications | 0);
    }
    get ActionCount() {
        const x = this;
        return x.PendingApplications | 0;
    }
}

export function DirectDebitStatus$reflection() {
    return record_type("Containers.StatusAndWarnings.Model.DirectDebitStatus", [], DirectDebitStatus, () => [["PendingApplications", int32_type], ["ApprovedApplications", int32_type], ["NotApprovedApplications", int32_type]]);
}

export class PaymentDemandChainStatus extends Record {
    constructor(ActiveStoppedClaimsWithUnpaidInvoices, ActiveInvoiceesWithReminders, ActiveInvoiceesWithDebtCollection, CancelledStoppedClaimsWithUnpaidInvoices, ActiveWith1InvoiceDebtsNotPayed, ActiveWith1InvoiceDebtsHasPayed, ActiveWith2InvoiceDebtsNotPayed, ActiveWith2InvoiceDebtsHasPayed, ActiveWithManyInvoiceDebts, InvoiceesWithEndDate, InvoiceesNonMonthlyWith1MoreDebts, AllInvoiceeWithTwoOrMoreDebtcollection) {
        super();
        this.ActiveStoppedClaimsWithUnpaidInvoices = (ActiveStoppedClaimsWithUnpaidInvoices | 0);
        this.ActiveInvoiceesWithReminders = (ActiveInvoiceesWithReminders | 0);
        this.ActiveInvoiceesWithDebtCollection = (ActiveInvoiceesWithDebtCollection | 0);
        this.CancelledStoppedClaimsWithUnpaidInvoices = (CancelledStoppedClaimsWithUnpaidInvoices | 0);
        this.ActiveWith1InvoiceDebtsNotPayed = (ActiveWith1InvoiceDebtsNotPayed | 0);
        this.ActiveWith1InvoiceDebtsHasPayed = (ActiveWith1InvoiceDebtsHasPayed | 0);
        this.ActiveWith2InvoiceDebtsNotPayed = (ActiveWith2InvoiceDebtsNotPayed | 0);
        this.ActiveWith2InvoiceDebtsHasPayed = (ActiveWith2InvoiceDebtsHasPayed | 0);
        this.ActiveWithManyInvoiceDebts = (ActiveWithManyInvoiceDebts | 0);
        this.InvoiceesWithEndDate = (InvoiceesWithEndDate | 0);
        this.InvoiceesNonMonthlyWith1MoreDebts = (InvoiceesNonMonthlyWith1MoreDebts | 0);
        this.AllInvoiceeWithTwoOrMoreDebtcollection = (AllInvoiceeWithTwoOrMoreDebtcollection | 0);
    }
    get ActionCount() {
        const x = this;
        return (((((((((((x.ActiveStoppedClaimsWithUnpaidInvoices + x.ActiveInvoiceesWithReminders) + x.ActiveInvoiceesWithDebtCollection) + x.CancelledStoppedClaimsWithUnpaidInvoices) + x.ActiveWith1InvoiceDebtsNotPayed) + x.ActiveWith1InvoiceDebtsHasPayed) + x.ActiveWith2InvoiceDebtsNotPayed) + x.ActiveWith2InvoiceDebtsHasPayed) + x.ActiveWithManyInvoiceDebts) + x.InvoiceesWithEndDate) + x.InvoiceesNonMonthlyWith1MoreDebts) + x.AllInvoiceeWithTwoOrMoreDebtcollection) | 0;
    }
}

export function PaymentDemandChainStatus$reflection() {
    return record_type("Containers.StatusAndWarnings.Model.PaymentDemandChainStatus", [], PaymentDemandChainStatus, () => [["ActiveStoppedClaimsWithUnpaidInvoices", int32_type], ["ActiveInvoiceesWithReminders", int32_type], ["ActiveInvoiceesWithDebtCollection", int32_type], ["CancelledStoppedClaimsWithUnpaidInvoices", int32_type], ["ActiveWith1InvoiceDebtsNotPayed", int32_type], ["ActiveWith1InvoiceDebtsHasPayed", int32_type], ["ActiveWith2InvoiceDebtsNotPayed", int32_type], ["ActiveWith2InvoiceDebtsHasPayed", int32_type], ["ActiveWithManyInvoiceDebts", int32_type], ["InvoiceesWithEndDate", int32_type], ["InvoiceesNonMonthlyWith1MoreDebts", int32_type], ["AllInvoiceeWithTwoOrMoreDebtcollection", int32_type]]);
}

export class SubscriptionAndFeesStatus extends Record {
    constructor(ActiveWithNoFees, PendingNoFeesNoStartDate, PendingNoFeesWithStartDate, OnlyNegativeFees, ManyNegativeFees) {
        super();
        this.ActiveWithNoFees = (ActiveWithNoFees | 0);
        this.PendingNoFeesNoStartDate = (PendingNoFeesNoStartDate | 0);
        this.PendingNoFeesWithStartDate = (PendingNoFeesWithStartDate | 0);
        this.OnlyNegativeFees = (OnlyNegativeFees | 0);
        this.ManyNegativeFees = (ManyNegativeFees | 0);
    }
    get ActionCount() {
        const x = this;
        return ((((x.ActiveWithNoFees + x.PendingNoFeesNoStartDate) + x.PendingNoFeesWithStartDate) + x.OnlyNegativeFees) + x.ManyNegativeFees) | 0;
    }
}

export function SubscriptionAndFeesStatus$reflection() {
    return record_type("Containers.StatusAndWarnings.Model.SubscriptionAndFeesStatus", [], SubscriptionAndFeesStatus, () => [["ActiveWithNoFees", int32_type], ["PendingNoFeesNoStartDate", int32_type], ["PendingNoFeesWithStartDate", int32_type], ["OnlyNegativeFees", int32_type], ["ManyNegativeFees", int32_type]]);
}

export class TelecomStatus extends Record {
    constructor(ActiveMobileNoFees, ActiveTabIpNoFees, ActiveTrafficRedirectsNoActiveNumber) {
        super();
        this.ActiveMobileNoFees = (ActiveMobileNoFees | 0);
        this.ActiveTabIpNoFees = (ActiveTabIpNoFees | 0);
        this.ActiveTrafficRedirectsNoActiveNumber = (ActiveTrafficRedirectsNoActiveNumber | 0);
    }
    get ActionCount() {
        const x = this;
        return ((x.ActiveMobileNoFees + x.ActiveTabIpNoFees) + x.ActiveTrafficRedirectsNoActiveNumber) | 0;
    }
}

export function TelecomStatus$reflection() {
    return record_type("Containers.StatusAndWarnings.Model.TelecomStatus", [], TelecomStatus, () => [["ActiveMobileNoFees", int32_type], ["ActiveTabIpNoFees", int32_type], ["ActiveTrafficRedirectsNoActiveNumber", int32_type]]);
}

export class MortgageStatus extends Record {
    constructor(KK2_MortgageBlocked) {
        super();
        this.KK2_MortgageBlocked = (KK2_MortgageBlocked | 0);
    }
    get ActionCount() {
        const x = this;
        return x.KK2_MortgageBlocked | 0;
    }
}

export function MortgageStatus$reflection() {
    return record_type("Containers.StatusAndWarnings.Model.MortgageStatus", [], MortgageStatus, () => [["KK2_MortgageBlocked", int32_type]]);
}

export class Page extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Inportations", "Invoicing", "DirectDebit", "PaymentDemandChain", "SubscriptionAndFees", "Telecom", "MortgageStatus", "NotFound"];
    }
}

export function Page$reflection() {
    return union_type("Containers.StatusAndWarnings.Model.Page", [], Page, () => [[], [], [], [], [], [], [], []]);
}

export function Page_get_ToString() {
    return (_arg) => ((_arg.tag === 1) ? "Invoicing" : ((_arg.tag === 2) ? "DirectDebit" : ((_arg.tag === 3) ? "PaymentDemandChain" : ((_arg.tag === 4) ? "SubscriptionAndFees" : ((_arg.tag === 5) ? "Telecom" : ((_arg.tag === 6) ? "MortgageStatus" : ((_arg.tag === 7) ? "NotFound" : "Inportations")))))));
}

